import { TrackingPageTypeWithId } from '@aboutyou/legacy-tracking-sdk'
import { PageTrackingContextProvider } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import React, { FC } from 'react'
import { usePremiumPageStore } from 'store/context'
import styled from 'styled-components'
import RowSection from 'uiComponents/atoms/Sections/RowSection'
import PremiumBrandLogoSlider from './components/PremiumBrandLogoSlider'
import PremiumBrandOverview from './components/PremiumBrandOverview/PremiumBrandOverview'
import PremiumBrandSlider from './components/PremiumBrandSlider'
import PremiumEdits from './components/PremiumEdits'
import PremiumHeroSlider from './components/PremiumHeroSlider/PremiumHeroSlider'
import PremiumLooks from './components/PremiumLooks'
import PremiumOutfits from './components/PremiumOutfits'
import PremiumProducts from './components/PremiumProducts'
import PremiumTopCategoriesSlider from './components/PremiumTopCategoriesSlider'
import PremiumUSPs from './components/PremiumUSPs'
import useTrackPremiumPageView from './components/helpers/useTrackPremiumPageView'

const Devider = styled.hr`
  width: 100%;
  max-width: 1920px;
  margin-left: auto;
  margin-right: auto;
`
const PremiumPage: FC = () => {
  useTrackPremiumPageView()

  return (
    <>
      <PremiumHeroSlider />
      <RowSection pullStart pullEnd>
        <PremiumBrandLogoSlider />
      </RowSection>
      <Devider />
      <RowSection pullStart pullEnd>
        <PremiumTopCategoriesSlider />
      </RowSection>
      <RowSection pullStart pullEnd>
        <PremiumOutfits />
      </RowSection>
      <RowSection pullStart pullEnd>
        <PremiumBrandSlider />
      </RowSection>
      <RowSection pullStart pullEnd>
        <PremiumBrandOverview />
      </RowSection>
      <Devider />
      <RowSection pullStart pullEnd>
        <PremiumUSPs />
      </RowSection>
      <Devider />
      <RowSection pullStart pullEnd>
        <PremiumProducts />
      </RowSection>
      <RowSection>
        <PremiumLooks />
      </RowSection>
      <RowSection>
        <PremiumEdits />
      </RowSection>
    </>
  )
}

const TrackedPremiumPage: FC = () => {
  const categoryId = usePremiumPageStore(store => store.categoryId)
  const { path, search } = useTrackingPageUrl()

  return (
    <PageTrackingContextProvider
      id={Number(categoryId)}
      path={path}
      search={search}
      type={TrackingPageTypeWithId.Category}
    >
      <PremiumPage />
    </PageTrackingContextProvider>
  )
}

export default TrackedPremiumPage
